import { useGetQualificationsForWorkplaceType } from "@src/appV2/Admin/WorkplaceTypes/api/useGetQualificationsForWorkplaceType";

import { QualificationHolidayFeeOverridesEditor } from "./QualificationHolidayFeeOverridesEditor";

export interface QualificationHolidayFeeOverridesContainerProps {
  hcfId: string;
  hcfType: string;
  workplaceId: string;
  payOnHoliday: boolean;
}

export function QualificationHolidayFeeOverridesContainer(
  props: QualificationHolidayFeeOverridesContainerProps
): JSX.Element | null {
  const { hcfId, hcfType, workplaceId, payOnHoliday } = props;
  const { qualifications } = useGetQualificationsForWorkplaceType({
    workplaceTypeName: hcfType,
    workplaceId,
  });

  if (!payOnHoliday) {
    return null;
  }

  return (
    <QualificationHolidayFeeOverridesEditor
      hcfId={hcfId}
      qualifications={qualifications}
      workplaceId={workplaceId}
    />
  );
}
